
<app-radio-input-group #childPopulationsComponent [indication]="populationsIndication" [labelName]="'Populations to include'" [controlName]="'populations'" 
[controlDisplayName]="'Populations'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedPopulationsControlSelectionChangedHandler($event)"></app-radio-input-group>

<app-radio-input-group *ngIf="showDiagnosisSelections()" #childDiagnosisComponent [indication]="diagnosisIndication" [labelName]="'Diagnosis'" [controlName]="'diagnosis'" 
[controlDisplayName]="'Diagnosis'" [hasCustomControlParent]="true" (indicationSelectionChanged)="childSharedDiagnosisControlSelectionChangedHandler($event)"></app-radio-input-group>
<br />

<div class="criteria-section" *ngIf="showCriteriaSection()">
  <kendo-label
  [text]="'Disease Criteria'"
  class="input-label-header"
  ></kendo-label>
  <hr class="input-label-header-hr" />
</div>
<form [formGroup]="formGroup" [hidden]="!showCriteriaSection()">
  <div class="row mb-3 mt-3">
    <div class="col-sm-6 form-check">
      <kendo-label style="padding-left: 12px" [text]="diagnosedDiabeticRetinopathyLabel + ':'"></kendo-label>
    </div>
    <div class="col-sm-6 radio-wrapper">
      <div class="form-check white-inputs" *ngFor="let inputOption of diagnosedDiabeticRetinopathyRadioInputOptions">
        <kendo-label
          class="form-check-label"
          [for]="radioOption"
          [text]="inputOption.displayName"
        ></kendo-label>
        <input
          class="form-check-input"
          type="radio"
          name="{{diagnosedDiabeticRetinopathyVariableName}}"
          #radioOption
          [value]="inputOption.name"
          formControlName="{{diagnosedDiabeticRetinopathyVariableName}}"
          kendoRadioButton
          (change)="updateSelections()"
        />
      </div>
    </div>
  </div>
  <div class="form-check row">
    <div class="col-12 mb-1">
      <input class="form-check-input" type="checkbox" (change)="criteriaCheckboxChanged('f')" formControlName="fastingPlasmaGlucoseLevelCheckbox" #fastingPlasmaGlucoseLevelCheckbox />
      <kendo-label [ngStyle]="{'text-decoration': fastingPlasmaGlucoseLevelDisabled() ? 'line-through' : 'none' }" class="k-form" [text]="diabetesInputOptions[1][0].displayName" style="color: #92929f;" [for]="fastingPlasmaGlucoseLevelCheckbox">
        <kendo-textbox
          [disabled]="fastingPlasmaGlucoseLevelDisabled()"
          [style.max-width.px]="300"
          [style.min-width.px]="150"
          [formControlName]="diabetesInputOptions[1][0].name"
          placeholder=""
          [clearButton]="true"
          (valueChange)="updateSelections()"
        >
        </kendo-textbox>
      </kendo-label>
    </div>
  </div>
  <div class="row" *ngIf="!conditionDisabled()">
    <div class="form-check condition-radios" *ngFor="let inputOption of diabetesInputOptions[0]">
        <kendo-label
          class="form-check-label"
          [for]="radioOption"
          [text]="inputOption.displayName"
        ></kendo-label>
        <input
          class="form-check-input"
          type="radio"
          name="condition"
          #radioOption
          [value]="inputOption.name"
          formControlName="condition"
          kendoRadioButton
          (change)="updateSelections()"
        />
    </div>
  </div>
  <div class="form-check row">
    <div class="col-12 mb-1">
    <input class="form-check-input" type="checkbox" (change)="criteriaCheckboxChanged('g')" formControlName="glycohemoglobinCheckbox" #glycohemoglobinCheckbox />
    <kendo-label [ngStyle]="{'text-decoration': glycohemoglobinDisabled() ? 'line-through' : 'none' }" class="k-form" [text]="diabetesInputOptions[1][1].displayName" style="color: #92929f;" [for]="glycohemoglobinCheckbox">
      <kendo-textbox
        [disabled]="glycohemoglobinDisabled()"
        [style.max-width.px]="300"
        [style.min-width.px]="150"
        [formControlName]="diabetesInputOptions[1][1].name"
        placeholder=""
        [clearButton]="true"
        (valueChange)="updateSelections()"
      >
      </kendo-textbox>
    </kendo-label>
    </div>
  </div>
</form>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
